import request from '@/utils/request'

export const qrcode = {
    // 获取二维码图片（直接返回图片流）
    getQRCodeImage(params) {
        return request({
            method: 'get',
            url: '/api/qrcode/image',
            params: params,
            responseType: 'blob'  // 关键：处理图片流
        })
    },
    
    // 获取二维码 Base64
    getQRCodeBase64(params) {
        return request({
            method: 'get',
            url: '/qrcode',
            params: params
        })
    },
    
    // 获取带 Logo 的二维码
    getQRCodeWithLogo(params) {
        return request({
            method: 'get',
            url: '/api/qrcode/logo',
            params: params
        })
    },
    
    // 下载二维码
    downloadQRCode(params) {
        return request({
            method: 'get',
            url: '/api/qrcode/download',
            params: params,
            responseType: 'blob'
        })
    }
}